import moment from 'moment';

// helper function for download
export const downloadBase64File = (base64String, moduleName) => {
    try {
        let fileName = moduleName + "_" + moment().format('MMDDYYYY_HHmmss') + '.xlsx';

        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        return true;
    } catch (err) {
        console.error("Download failed:", err);
        return false;
    }
};

export const getImageByFileExtension = (fileName) => {
    if (!fileName) return "/assets/images/thumbnails/pdfFG.png";

    const extension = fileName.split('.').pop()?.toLowerCase();
    const imageMap = {
        'pdf': '/assets/images/thumbnails/pdfFG.png',
        'doc': '/assets/images/thumbnails/wordFG.png',
        'docx': '/assets/images/thumbnails/wordFG.png',
        'xls': '/assets/images/thumbnails/excelFG.png',
        'xlsx': '/assets/images/thumbnails/excelFG.png',
        'ppt': '/assets/images/thumbnails/pptFG.png',
        'pptx': '/assets/images/thumbnails/pptFG.png',
        'txt': '/assets/images/thumbnails/txtFG.png',
        'png': '/assets/images/thumbnails/imageFG.png',
        'jpg': '/assets/images/thumbnails/imageFG.png',
        'jpeg': '/assets/images/thumbnails/imageFG.png',
        'mp4': '/assets/images/thumbnails/videoFG.png',
        'mov': '/assets/images/thumbnails/videoFG.png',
        'avi': '/assets/images/thumbnails/videoFG.png',
        'webm': '/assets/images/thumbnails/videoFG.png',
    };
    return imageMap[extension] || '/assets/images/thumbnails/pdfFG.png';
};

export const getMimeType = (fileType) => {
    const mimeTypeMap = {
        'pdf': 'application/pdf',
        'doc': 'application/msword',
        'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'xls': 'application/vnd.ms-excel',
        'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'ppt': 'application/vnd.ms-powerpoint',
        'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'txt': 'text/plain',
        'png': 'image/png',
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'mp4': 'video/mp4',
        'mov': 'video/quicktime',
        'avi': 'video/x-msvideo',
        'webm': 'video/webm',
    };
    return mimeTypeMap[fileType.toLowerCase()] || 'application/octet-stream';
}

export const convertStreamToBlob = async (stream, mimeType) => {
    try {
        let arrayBuffer;

        // Handle if stream is already an ArrayBuffer
        if (stream instanceof ArrayBuffer) {
            arrayBuffer = stream;
        }
        // Handle if stream is a Blob
        else if (stream instanceof Blob) {
            arrayBuffer = await stream.arrayBuffer();
        }
        // Handle if stream is a Response object
        else if (stream instanceof Response) {
            arrayBuffer = await stream.arrayBuffer();
        }
        // Handle if stream is a ReadableStream
        else if (stream.getReader) {
            const reader = stream.getReader();
            const chunks = [];
            let result;
            while (!(result = await reader.read()).done) {
                chunks.push(result.value);
            }
            const totalLength = chunks.reduce((acc, chunk) => acc + chunk.length, 0);
            const uint8Array = new Uint8Array(totalLength);
            let position = 0;
            for (const chunk of chunks) {
                uint8Array.set(chunk, position);
                position += chunk.length;
            }
            arrayBuffer = uint8Array.buffer;
        }
        // Fallback for other types
        else if (typeof stream === 'string') {
            const encoder = new TextEncoder();
            arrayBuffer = encoder.encode(stream).buffer;
        }
        else {
            throw new Error('Unsupported stream type');
        }

        // Use provided mimeType or default to PDF
        const finalMimeType = mimeType || "application/pdf";
        const blob = new Blob([arrayBuffer], { type: finalMimeType });
        const objectUrl = URL.createObjectURL(blob);

        return objectUrl;
    } catch (err) {
        console.error('Error converting stream to blob:', err);
        throw err;
    }
}

export const downloadBlobUrl = (blobUrl, fileName) => {
    try {
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
        return true;
    } catch (err) {
        console.error('Download failed:', err);
        return false;
    }
}